import { isMetadataWithDocumentData, metadataStrategyOverwrite, MismatchedMetadataFlavorError, } from "../metadata";
/**
 * The document converter is special because:
 *  - The data field name is 'documentData' not 'data'
 *  - The metadata type is different (e.g. it contains actionRecordMetaData, schemaVersion, etc.)
 *     - Notably, we can't completely overwrite the metadata on write, because we need to keep the actionRecordMetaData
 *  - The base document does NOT go through flatObjectToInterface/interfaceDataToFlatObject - formerly the converter
 * used was the 'empty' converter, not the standard 'unsafe' one
 *     - This means this converter is also almost empty: it distinguishes writing from reading the metadata, and
 * corrects any missing fields, and that's it.
 */
class BaseDocumentConverter {
    metadataGenerator;
    metadataStrategy;
    constructor(metadataGenerator, metadataStrategy = metadataStrategyOverwrite("baseDocument")) {
        this.metadataGenerator = metadataGenerator;
        this.metadataStrategy = metadataStrategy;
    }
    deserialize(snapshot) {
        const serializedModelObject = snapshot.data();
        if (!isMetadataWithDocumentData(serializedModelObject)) {
            throw new MismatchedMetadataFlavorError("baseDocument");
        }
        const documentData = serializedModelObject.documentData;
        documentData.uid = snapshot.id;
        return {
            documentData,
            metadata: serializedModelObject.metadata,
        };
    }
    serialize(document) {
        if (!isMetadataWithDocumentData(document)) {
            throw new MismatchedMetadataFlavorError("baseDocument");
        }
        const documentData = document.documentData;
        let metadata = {
            ...document.metadata,
            ...this.metadataGenerator.generate("baseDocument"),
        };
        if (this.metadataStrategy.writeStrategy === "specify") {
            metadata = this.metadataStrategy.metadata;
        }
        return {
            documentData,
            metadata,
        };
    }
}
export class DocumentAdminConverter extends BaseDocumentConverter {
    toFirestore(modelObject) {
        return this.serialize(modelObject);
    }
    fromFirestore(snapshot) {
        return this.deserialize(snapshot);
    }
}
export class DocumentClientConverter extends BaseDocumentConverter {
    toFirestore(modelObject) {
        return this.serialize(modelObject);
    }
    fromFirestore(snapshot) {
        return this.deserialize(snapshot);
    }
}
//# sourceMappingURL=DocumentConverter.js.map